export default "__VITE_ASSET__5487d14d__"